import "../scrap.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate } from "react-router-dom";
import { SparkTabNavigation } from "@bosch-web-dds/spark-ui-react";
import { getScrapCategoriesApproved } from "../scraps-service";
import { useAuth } from "../../../contexts/auth-context";
import { ScrapsCategoryInfoDTO } from "../scrap-category/models/scrap-category-DTO";

const ScrapTab: React.FC<{ enabledUsers: string[] }> = ({ enabledUsers }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userDoc, loading } = useAuth();
  const profile = userDoc?.profile;
  const [selectedTab, setSelectedTab] = useState("scraps-group");

  const tabs = [
    { value: "scraps-group", label: t("label-scrap-groups") },
    { value: "scraps-category", label: t("label-scrap-categories") },
    { value: "scraps-to-deal", label: t("label-toDeal") },
    { value: "scraps-in-bid", label: t("label-in-bid") },
    { value: "scraps-in-approval", label: t("label-in-approval") },
    { value: "contracts", label: t("statusEnum.CONTRACTED") },
    { value: "scraps-inactive", label: t("label-inactive") },
  ];

  const [scrapCategories, setScrapCategories] = useState<
    ScrapsCategoryInfoDTO[]
  >([]);

  const fetchScrapCategories = async () => {
    try {
      const data = await getScrapCategoriesApproved();
      setScrapCategories(data);
    } catch (error) {
      console.error("Error fetching scrap categories: ", error);
    }
  };

  useEffect(() => {
    fetchScrapCategories();
  }, []);

  const handleCloseModal = () => {
    fetchScrapCategories();
  };
  const handleTabChange = (event: Event, data: { value: string }) => {
    const newTab = data.value;

    setSelectedTab(newTab);

    navigate(newTab);
  };

  if (loading) return null;

  if (enabledUsers.includes(profile || "public")) {
    return (
      <div className="page">
        <SparkTabNavigation
          items={JSON.stringify(tabs)}
          selectedTab={selectedTab}
          whenChange={handleTabChange}
        />
        <Outlet />

      </div>
    );
  } else {
    navigate("/page-not-found")
    return <></>
  }
};

export default ScrapTab;
